import React from "react";
import { useDispatch } from "react-redux";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { TextField, SubmitBtn, DateInputField } from "capitalrx-components";

import SectionContainer from "@/App/components/SectionContainer";
import ClearFieldsButton from "@/App/components/ClearFieldsButton";
import { memberSearchAction } from "@/App/actions";
import { MembersTypes } from "@/types";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

type Props = InjectedFormProps;
const FORM_NAME = "PatientSearchForm";

const INITIAL_QUERY_OPTIONS: MembersTypes.MemberSearchOptions = {
  order_by: [],
  page_number: 1,
  results_per_page: 20,
};

const PatientSearchForm: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const { submitting, handleSubmit } = props;
  const { userSearchForMembers } = memberSearchAction;

  const handleFormSubmit = (data: MembersTypes.MemberSearchOptions): void => {
    // on form submit, reset the pagination/sorting to default
    dispatch(
      userSearchForMembers({
        data: { ...INITIAL_QUERY_OPTIONS, ...data },
        formName: FORM_NAME,
      }),
    );

    // capture button press
    logEvent(ANALYTIC_EVENTS.MANUAL_CLAIM_PATIENT.searchForPatient);

    // also wants to be able to capture which text fields held data
    const fieldToAnalyticsKey: { [index: string]: string } = {
      first_name: ANALYTIC_EVENTS.MANUAL_CLAIM_PATIENT.searchCriteriaFieldFirstName,
      last_name: ANALYTIC_EVENTS.MANUAL_CLAIM_PATIENT.searchCriteriaFieldLastName,
      date_of_birth: ANALYTIC_EVENTS.MANUAL_CLAIM_PATIENT.searchCriteriaFieldDOB,
      external_member_id: ANALYTIC_EVENTS.MANUAL_CLAIM_PATIENT.searchCriteriaFieldMemberID,
    };
    Object.keys(data).forEach((key) => {
      logEvent(fieldToAnalyticsKey[key]);
    });
  };

  return (
    <SectionContainer headerTitle={"Search criteria"} abilityToClose>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="row">
          <div className="col">
            <Field component={TextField} id="first-name" data-testid="first-name" name="first_name" label="First Name" type="text" />
          </div>
          <div className="col">
            <Field component={TextField} id="last-name" data-testid="last-name" name="last_name" label="Last Name" type="text" />
          </div>
          <div className="col">
            <Field
              component={DateInputField}
              id="date_of_birth"
              data-testid={"date_of_birth"}
              name="date_of_birth"
              label="Date Of Birth"
              type="text"
            />
          </div>
          <div className="col">
            <Field
              component={TextField}
              id="member-id"
              data-testid="member-id"
              name="external_member_id"
              label="Member ID"
              type="text"
            />
          </div>
        </div>

        <div className="row caprx-h-center-text">
          <SubmitBtn fullWidth={false} submitting={submitting}>
            Search for patient
          </SubmitBtn>
        </div>

        <ClearFieldsButton formName={FORM_NAME} />
      </form>
    </SectionContainer>
  );
};

export default reduxForm({ form: FORM_NAME })(PatientSearchForm);
